/* eslint frontbucket-patterns/no-new-emotion-styled: "warn" */
import styled from '@emotion/styled';

import { gridSize } from '@atlaskit/theme';
import { token } from '@atlaskit/tokens';

export const ProjectLabel = styled.div({
  padding: `0 ${gridSize() / 2}px`,
});

export const CustomOption = styled.div({
  display: 'flex',
  alignItems: 'center',
});

export const ProjectIcon = styled.img({
  height: `${gridSize() * 2}px`,
  borderRadius: '3px',
});

export const LabelContainer = styled.div({
  display: 'flex',
  flexDirection: 'column',
  paddingLeft: `${gridSize()}px`,
});

export const ProjectDropdownTextContainer = styled.div({
  padding: `0 ${gridSize() * 2}px ${gridSize() * 2}px`,
  font: token('font.body'),
  color: token('color.text.subtlest'),
});

export const MenuContainer = styled.div({
  width: `${gridSize() * 40}px`,
  maxWidth: '100%',
});

export const OptionSiteLabel = styled.div({
  font: token('font.body'),
  color: token('color.text.subtlest'),
});

export const OptionSiteLabelSelected = styled.div({
  font: token('font.body'),
  textDecoration: 'none',
  color: 'inherit',
});
